import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SewerTinderDashboardGuard = createFeatureGuard(Feature.SewerDashboard);